import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import SigninRequest from "Communication/ApiClasses/SigninRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";
import {
  TOKEN_KEY,
  IS_LOGOUT,
  S_APPLICANT_ID,
  EXPIRES_AT,
  REFRESH_EXPIRES_AT,
  S_MSISDN,
  S_EMAIL,
  S_SSO,
  S_PERSONAL,
  S_INSTNT_TXN_ID_QR,
  APP_SMARTBRANCH,
  S_ACCOUNT_ID,
  S_STAFF_MSISDN,
  S_STAFF_EMAIL,
  S_STAFF_ID,
} from "../../../Communication/Constants";
import AppConstants from "../../../Constants/AppConstants";
import { isInBranchFlow } from "../../../Utils/LogicUtilities";

//  worker
function* handleSignin(action) {
  if (
    process.env.REACT_APP_TYPE !== APP_SMARTBRANCH ||
    (isInBranchFlow() && !action.data?.otp && !action.data?.otpId)
  ) {
    yield put(doLoadingStart(STRINGS.SIGNIN.API_KEYS.SIGNIN, "", action.data));
  }
  const signinApi = new SigninRequest(action.data);
  try {
    const result = yield call(signinApi.getData);
    sessionStorage.setItem(TOKEN_KEY, result.data.token);
    if (result.data.bankingType === AppConstants.BANKING_TYPE.STAFF) {
      sessionStorage.setItem(S_STAFF_MSISDN, result.data.msisdn);
      sessionStorage.setItem(S_STAFF_EMAIL, result.data.email);
      sessionStorage.setItem(S_STAFF_ID, result.data.id);
    } else {
      sessionStorage.setItem(S_MSISDN, result.data.msisdn);
      sessionStorage.setItem(S_EMAIL, result.data.email);
      sessionStorage.setItem(S_ACCOUNT_ID, result.data.id);
    }
    sessionStorage.setItem(S_PERSONAL, result.data.personalId);
    sessionStorage.setItem(S_SSO, "no");
    sessionStorage.removeItem(S_APPLICANT_ID);
    sessionStorage.removeItem(S_INSTNT_TXN_ID_QR);
    sessionStorage.removeItem(AppConstants.SESSION.DEBIT_CARD_ALREADY_LOADED);
    sessionStorage.setItem(IS_LOGOUT, "false");
    sessionStorage.setItem(EXPIRES_AT, result.data.expiresAt);
    sessionStorage.setItem(REFRESH_EXPIRES_AT, result.data.refreshExpiresAt);
    yield put({ type: actionTypes.SIGNIN_RESPONSE, success: result });
    // yield put({
    //   type: actionTypes.GET_ACCESS_TOKEN,
    //   timeout: result.data.expiresAt,
    // });
    yield call(action.callback, result);
  } catch (e) {
    console.log(e);
    yield put({ type: actionTypes.SIGNIN_ERROR, error: e.message });
    yield call(action.callback, { error: e.message });
  } finally {
    yield put(doLoadingFinish(STRINGS.SIGNIN.API_KEYS.SIGNIN));
  }
}

//  watcher
export default function* signinWatcherSaga() {
  yield takeLatest(actionTypes.SIGNIN_REQUEST, handleSignin);
}
